// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.compliance-report .panel {
  border: 1px solid #ddd;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
  background: linear-gradient(135deg, #f5f7fa, #DBDCDD);
}
.compliance-report .report-label {
  font-weight: bold;
  display: block;
  margin-bottom: 6px;
}
.compliance-report .category-link {
  color: #0066B2;
  text-decoration: none;
  cursor: pointer;
  font-weight: 600;
}
.compliance-report .category-link:hover {
  text-decoration: underline;
}
.compliance-report .search-box {
  position: relative;
}
.compliance-report .search-box i {
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  color: #6c757d;
}
.compliance-report .search-box input {
  padding-left: 30px;
  padding-right: 30px;
  min-width: 260px;
}
.compliance-report .search-box .clear-icon {
  left: auto;
  right: 10px;
  cursor: pointer;
}
.compliance-report .search-box .clear-icon:hover {
  color: #343a40;
}
.compliance-report .category-detail-header .search-box {
  margin-right: 2.5rem;
}
.compliance-report .hours-tabs {
  display: flex;
  width: 100%;
  border-bottom: 2px solid #e0e0e0;
}
.compliance-report .hours-tabs ::ng-deep .p-selectbutton,
.compliance-report .hours-tabs ::ng-deep .p-togglebutton {
  display: flex;
  width: 100%;
}
.compliance-report .hours-tabs ::ng-deep .p-togglebutton {
  flex: 1 1 0;
  background: transparent;
  border: none;
  border-bottom: 3px solid transparent;
  border-radius: 0;
  color: #6c757d;
  font-weight: 600;
  padding: 12px 0;
}
.compliance-report .hours-tabs ::ng-deep .p-togglebutton .p-togglebutton-label {
  width: 100%;
  text-align: center;
}
.compliance-report .hours-tabs ::ng-deep .p-togglebutton:hover {
  background: rgba(123, 31, 111, 0.04);
}
.compliance-report .hours-tabs ::ng-deep .p-togglebutton.p-togglebutton-checked, .compliance-report .hours-tabs ::ng-deep .p-togglebutton.p-highlight {
  background: transparent;
  color: #7B1F6F;
  border-bottom-color: #7B1F6F;
}
.compliance-report .btn-primary {
  background: #0B2D71;
  color: #fff;
  border: none;
  border-radius: 0;
  font-family: "GothamBold", "Helvetica Neue", "Helvetica", "Arial", "sans-serif";
  font-size: 0.88em;
  cursor: pointer;
  padding: 8px 16px;
}
.compliance-report .btn-primary:hover {
  background: #0066B2;
}
.compliance-report .margin {
  margin-left: 10px;
}
.compliance-report .summary-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.compliance-report .summary-card .summary-title {
  font-weight: bold;
  color: #0B2D71;
  font-size: 1rem;
  margin-bottom: 8px;
}
.compliance-report .summary-card .summary-value {
  font-size: 1.8rem;
  font-weight: bold;
  color: #0066B2;
}
.compliance-report .chart-panel h4 {
  text-align: center;
  color: #0B2D71;
  margin-bottom: 16px;
}
.compliance-report .chart-container {
  position: relative;
  min-height: 360px;
}
.compliance-report .chart-dark {
  background: linear-gradient(135deg, #3a3a3a, #2b2b2b);
  border-radius: 8px;
  padding: 12px;
}
.compliance-report .text-end {
  text-align: right;
}
.compliance-report .nested-table {
  background: #f0f4f8;
}
.compliance-report .nested-table th {
  background: #e2e8f0;
}
.compliance-report .wbs-breadcrumb-panel {
  padding: 0.75rem 1rem;
  background: #eef1f6;
  border-bottom: 1px solid #e6e6e6;
}
.compliance-report .wbs-breadcrumb-title {
  font-weight: 700;
  color: #2b2b2b;
  margin-bottom: 0.35rem;
}
.compliance-report .wbs-breadcrumb {
  font-size: 0.85rem;
  color: #4a4a4a;
  line-height: 1.4;
  margin-top: 0.25rem;
}
.compliance-report .wbs-breadcrumb-sep {
  color: #8a8a8a;
}
.compliance-report .wp-accordion {
  overflow: auto;
}
.compliance-report .wp-table {
  width: 100%;
  border-collapse: collapse;
}
.compliance-report .wp-table th,
.compliance-report .wp-table td {
  padding: 0.5rem 0.75rem;
  border-bottom: 1px solid #e6e6e6;
  vertical-align: top;
}
.compliance-report .wp-table thead th {
  background: #f5f5f5;
  font-weight: 600;
  color: #333;
  white-space: nowrap;
}
.compliance-report .wp-table thead th.sortable-header {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.compliance-report .wp-table thead th.sortable-header:hover {
  background: #ebedf3;
}
.compliance-report .wp-table thead th.sortable-header .pi {
  margin-left: 0.35rem;
}
.compliance-report .wp-table .pi {
  color: #464feb;
  font-size: 0.8rem;
}
.compliance-report .wp-row {
  cursor: pointer;
}
.compliance-report .wp-row:hover {
  background: #f0f4ff;
}
.compliance-report .wp-detail-row > td {
  background: #f7f9fc;
}
.compliance-report .wp-table.nested-table {
  background: #f0f4f8;
}
.compliance-report .wp-table.nested-table thead th {
  background: #e2e8f0;
}`, "",{"version":3,"sources":["webpack://./src/pages/reporting/compliance-report/compliance-report.component.scss"],"names":[],"mappings":"AAEE;EACE,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,yCAAA;EACA,qDAAA;AADJ;AAIE;EACE,iBAAA;EACA,cAAA;EACA,kBAAA;AAFJ;AAKE;EACE,cAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;AAHJ;AAKI;EACE,0BAAA;AAHN;AAOE;EACE,kBAAA;AALJ;AAOI;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,2BAAA;EACA,cAAA;AALN;AAQI;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;AANN;AASI;EACE,UAAA;EACA,WAAA;EACA,eAAA;AAPN;AASM;EACE,cAAA;AAPR;AAaI;EACE,oBAAA;AAXN;AAeE;EACE,aAAA;EACA,WAAA;EACA,gCAAA;AAbJ;AAeI;;EAEE,aAAA;EACA,WAAA;AAbN;AAgBI;EACE,WAAA;EACA,uBAAA;EACA,YAAA;EACA,oCAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AAdN;AAgBM;EACE,WAAA;EACA,kBAAA;AAdR;AAiBM;EACE,oCAAA;AAfR;AAkBM;EAEE,uBAAA;EACA,cAAA;EACA,4BAAA;AAjBR;AAsBE;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,+EAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;AApBJ;AAsBI;EACE,mBAAA;AApBN;AAwBE;EACE,iBAAA;AAtBJ;AAyBE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAvBJ;AAyBI;EACE,iBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AAvBN;AA0BI;EACE,iBAAA;EACA,iBAAA;EACA,cAAA;AAxBN;AA6BI;EACE,kBAAA;EACA,cAAA;EACA,mBAAA;AA3BN;AA+BE;EACE,kBAAA;EACA,iBAAA;AA7BJ;AAgCE;EACE,qDAAA;EACA,kBAAA;EACA,aAAA;AA9BJ;AAiCE;EACE,iBAAA;AA/BJ;AAkCE;EACE,mBAAA;AAhCJ;AAkCI;EACE,mBAAA;AAhCN;AAoCE;EACE,qBAAA;EACA,mBAAA;EACA,gCAAA;AAlCJ;AAqCE;EACE,gBAAA;EACA,cAAA;EACA,sBAAA;AAnCJ;AAsCE;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AApCJ;AAuCE;EACE,cAAA;AArCJ;AAwCE;EACE,cAAA;AAtCJ;AAyCE;EACE,WAAA;EACA,yBAAA;AAvCJ;AAyCI;;EAEE,uBAAA;EACA,gCAAA;EACA,mBAAA;AAvCN;AA0CI;EACE,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;AAxCN;AA2CI;EACE,eAAA;EACA,yBAAA;UAAA,iBAAA;AAzCN;AA2CM;EACE,mBAAA;AAzCR;AA4CM;EACE,oBAAA;AA1CR;AA8CI;EACE,cAAA;EACA,iBAAA;AA5CN;AAgDE;EACE,eAAA;AA9CJ;AAgDI;EACE,mBAAA;AA9CN;AAkDE;EACE,mBAAA;AAhDJ;AAmDE;EACE,mBAAA;AAjDJ;AAmDI;EACE,mBAAA;AAjDN","sourcesContent":[".compliance-report {\n\n  .panel {\n    border: 1px solid #ddd;\n    border-radius: 12px;\n    padding: 20px;\n    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);\n    background: linear-gradient(135deg, #f5f7fa, #DBDCDD);\n  }\n\n  .report-label {\n    font-weight: bold;\n    display: block;\n    margin-bottom: 6px;\n  }\n\n  .category-link {\n    color: #0066B2;\n    text-decoration: none;\n    cursor: pointer;\n    font-weight: 600;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  .search-box {\n    position: relative;\n\n    i {\n      position: absolute;\n      top: 50%;\n      left: 10px;\n      transform: translateY(-50%);\n      color: #6c757d;\n    }\n\n    input {\n      padding-left: 30px;\n      padding-right: 30px;\n      min-width: 260px;\n    }\n\n    .clear-icon {\n      left: auto;\n      right: 10px;\n      cursor: pointer;\n\n      &:hover {\n        color: #343a40;\n      }\n    }\n  }\n\n  .category-detail-header {\n    .search-box {\n      margin-right: 2.5rem;\n    }\n  }\n\n  .hours-tabs {\n    display: flex;\n    width: 100%;\n    border-bottom: 2px solid #e0e0e0;\n\n    ::ng-deep .p-selectbutton,\n    ::ng-deep .p-togglebutton {\n      display: flex;\n      width: 100%;\n    }\n\n    ::ng-deep .p-togglebutton {\n      flex: 1 1 0;\n      background: transparent;\n      border: none;\n      border-bottom: 3px solid transparent;\n      border-radius: 0;\n      color: #6c757d;\n      font-weight: 600;\n      padding: 12px 0;\n\n      .p-togglebutton-label {\n        width: 100%;\n        text-align: center;\n      }\n\n      &:hover {\n        background: rgba(123, 31, 111, 0.04);\n      }\n\n      &.p-togglebutton-checked,\n      &.p-highlight {\n        background: transparent;\n        color: #7B1F6F;\n        border-bottom-color: #7B1F6F;\n      }\n    }\n  }\n\n  .btn-primary {\n    background: #0B2D71;\n    color: #fff;\n    border: none;\n    border-radius: 0;\n    font-family: 'GothamBold', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif';\n    font-size: 0.88em;\n    cursor: pointer;\n    padding: 8px 16px;\n\n    &:hover {\n      background: #0066B2;\n    }\n  }\n\n  .margin {\n    margin-left: 10px;\n  }\n\n  .summary-card {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n\n    .summary-title {\n      font-weight: bold;\n      color: #0B2D71;\n      font-size: 1rem;\n      margin-bottom: 8px;\n    }\n\n    .summary-value {\n      font-size: 1.8rem;\n      font-weight: bold;\n      color: #0066B2;\n    }\n  }\n\n  .chart-panel {\n    h4 {\n      text-align: center;\n      color: #0B2D71;\n      margin-bottom: 16px;\n    }\n  }\n\n  .chart-container {\n    position: relative;\n    min-height: 360px;\n  }\n\n  .chart-dark {\n    background: linear-gradient(135deg, #3a3a3a, #2b2b2b);\n    border-radius: 8px;\n    padding: 12px;\n  }\n\n  .text-end {\n    text-align: right;\n  }\n\n  .nested-table {\n    background: #f0f4f8;\n\n    th {\n      background: #e2e8f0;\n    }\n  }\n\n  .wbs-breadcrumb-panel {\n    padding: 0.75rem 1rem;\n    background: #eef1f6;\n    border-bottom: 1px solid #e6e6e6;\n  }\n\n  .wbs-breadcrumb-title {\n    font-weight: 700;\n    color: #2b2b2b;\n    margin-bottom: 0.35rem;\n  }\n\n  .wbs-breadcrumb {\n    font-size: 0.85rem;\n    color: #4a4a4a;\n    line-height: 1.4;\n    margin-top: 0.25rem;\n  }\n\n  .wbs-breadcrumb-sep {\n    color: #8a8a8a;\n  }\n\n  .wp-accordion {\n    overflow: auto;\n  }\n\n  .wp-table {\n    width: 100%;\n    border-collapse: collapse;\n\n    th,\n    td {\n      padding: 0.5rem 0.75rem;\n      border-bottom: 1px solid #e6e6e6;\n      vertical-align: top;\n    }\n\n    thead th {\n      background: #f5f5f5;\n      font-weight: 600;\n      color: #333;\n      white-space: nowrap;\n    }\n\n    thead th.sortable-header {\n      cursor: pointer;\n      user-select: none;\n\n      &:hover {\n        background: #ebedf3;\n      }\n\n      .pi {\n        margin-left: 0.35rem;\n      }\n    }\n\n    .pi {\n      color: #464feb;\n      font-size: 0.8rem;\n    }\n  }\n\n  .wp-row {\n    cursor: pointer;\n\n    &:hover {\n      background: #f0f4ff;\n    }\n  }\n\n  .wp-detail-row > td {\n    background: #f7f9fc;\n  }\n\n  .wp-table.nested-table {\n    background: #f0f4f8;\n\n    thead th {\n      background: #e2e8f0;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
